import { render } from "./StoreGiftDialog.vue?vue&type=template&id=56444cca&scoped=true"
import script from "./StoreGiftDialog.vue?vue&type=script&lang=js"
export * from "./StoreGiftDialog.vue?vue&type=script&lang=js"

import "./StoreGiftDialog.vue?vue&type=style&index=0&id=56444cca&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56444cca"]])

export default __exports__